// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bco_a bii_a bii_q bii_j bii_wl bii_bj","ImgResponsive__img":"bco_b bii_b bii_ql"};